import React from "react";

import styles from "./DialogHeader.module.scss";

interface Props {
  title: string;
  displayName?: string;
}

const DialogHeader = (props: Props) => {
  const { title, displayName } = props;

  return (
    <div className={styles.header}>
      <div className={styles.subtitle}>
        {`${displayName ? `${displayName}` : ""}`}
      </div>
      <div className={styles.title}>{title}</div>
    </div>
  );
};

export default DialogHeader;
